import { useParams } from "react-router";
import { Typography, Chip, theme } from "kosmos-ui";

import { useGetCompanyCategoryQuery } from "api/graphql/queries/company-category/hooks";
import { useLayout } from "app/context/LayoutContext/hooks";
import PosterCard from "app/components/PosterCard";
import RecommendationItemCard from "app/components/RecommendationItemCard";
import { ROUTES } from "app/constants/app";

import {
  CompaniesContainer,
  CompanyCategoryContainer,
  CompanyCategoryHeader,
  CompanyCategoryTagsContainer,
} from "./styles";

export default function CompanyCategory() {
  const { _id } = useParams<WithId>();

  const { data: companyCategoryData, loading: loadingCompanyCategoryData } =
    useGetCompanyCategoryQuery({ variables: { _id } });

  const { mobile, topbarHeight, announcementBarHeight } = useLayout();

  const companyCategory = companyCategoryData?.getCompanyCategory;

  const headerHeight = topbarHeight + announcementBarHeight;

  return (
    <CompanyCategoryContainer>
      {loadingCompanyCategoryData ? (
        <p>Cargando categoría...</p>
      ) : (
        <>
          <CompanyCategoryHeader headerHeight={headerHeight}>
            <PosterCard
              bgImg={companyCategory?.img}
              style={{ height: "50vh", maxHeight: 440 }}
            >
              <Typography as="h1" variant="title1" style={{ margin: 0 }}>
                {companyCategory?.name}
              </Typography>

              {companyCategory?.description && (
                <Typography
                  as="h2"
                  variant="paragraph1"
                  style={{ color: theme.colorsPalette.white.default }}
                >
                  {companyCategory.description}
                </Typography>
              )}

              {companyCategory?.tags && (
                <CompanyCategoryTagsContainer>
                  {companyCategory.tags.map((tag, index) => (
                    <Chip
                      type="secondary"
                      key={index}
                      style={{
                        backgroundColor: "rgb(255 255 255 / 40%)",
                        color: theme.colorsPalette.white.default,
                      }}
                    >
                      #{tag}
                    </Chip>
                  ))}
                </CompanyCategoryTagsContainer>
              )}
            </PosterCard>
          </CompanyCategoryHeader>

          <CompaniesContainer>
            {companyCategory?.companies.map((company) => (
              <RecommendationItemCard
                key={company._id}
                render="poster"
                item={{
                  color: company.color,
                  type: "company",
                  _id: company._id,
                  internalLink: `${ROUTES.company}/${company._id}`,
                  img: company.bgImg,
                  name: company.fantasyName,
                  description: company.description,
                }}
                style={{ card: { height: !mobile ? 232 : 164 } }}
              />
            ))}
          </CompaniesContainer>
        </>
      )}
    </CompanyCategoryContainer>
  );
}
